/*
 * Rez Preorder & Back In Stock app renders a "Powered by Rez Notification"
 * watermark link (free-plan branding) and re-applies its inline !important
 * styles on every variant change, so a CSS override can't hide it reliably.
 * Removing the node outright is the only stable fix.
 *
 * The preorder price itself is NOT handled here anymore: it's rendered
 * server-side (snippets/price-preorder.liquid). Toggling a class on Rez's
 * price element from JS fought with Rez resetting that class, and the
 * discount disappeared after a few interactions.
 *
 * Rez runs its own MutationObserver against this same page for price/stock
 * updates. Reacting to every single mutation record here (no batching) plus
 * removing nodes (itself a mutation) risked feeding back into that and
 * adding avoidable main-thread churn — batch to one pass per animation
 * frame and pause observing while we make our own DOM changes.
 */
(() => {
  const WATERMARK_SELECTOR = '.rez-preorder-watermark, .rez-preorder-powered-link';
  const OBSERVER_OPTIONS = {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class'],
  };

  const removeWatermarks = () => {
    document.querySelectorAll(WATERMARK_SELECTOR).forEach((node) => node.remove());
  };

  const observer = new MutationObserver(scheduleSync);

  function sync() {
    observer.disconnect();
    removeWatermarks();
    observer.observe(document.documentElement, OBSERVER_OPTIONS);
  }

  let syncScheduled = false;
  function scheduleSync() {
    if (syncScheduled) return;
    syncScheduled = true;
    requestAnimationFrame(() => {
      syncScheduled = false;
      sync();
    });
  }

  sync();
})();
